import * as HLF from "html-living-framework";
import * as Topics from "../Data/Topics";
import { KeyboardFocus } from "../GameObjects/KeyboardFocus";

export class KeyboardFocusManager extends PIXI.Container {
    private readonly _activeFoci: KeyboardFocus[];
    private readonly _focusPool: KeyboardFocus[];
    private readonly _pubSubTokens: any[];

    constructor() {
        super();

        this._pubSubTokens = new Array<any>();
        this._focusPool = new Array<KeyboardFocus>();
        this._activeFoci = new Array<KeyboardFocus>();

        this._pubSubTokens.push(PubSub.subscribe(Topics.KEYBOARD_FOCUS_BEGIN, this.onFocusBegin.bind(this)));
        this._pubSubTokens.push(PubSub.subscribe(Topics.KEYBOARD_FOCUS_END, this.onFocusEnd.bind(this)));
        this._pubSubTokens.push(PubSub.subscribe(Topics.KEYBOARD_REFOCUS, this.reFocus.bind(this)));
        this._pubSubTokens.push(PubSub.subscribe(Topics.KEYBOARD_FOCUSABLE_INTERACTIVE_CHANGED,
            this.onFocusableInteractiveChanged.bind(this)));
    }

    public destroy(pOptions?: boolean | PIXI.DestroyOptions): void {
        for (let i = this._activeFoci.length; i > 0; --i) {
            this._activeFoci?.pop()?.destroy(pOptions);
        }
        for (let i = this._focusPool.length; i > 0; --i) {
            this._focusPool.pop()?.destroy(pOptions);
        }
        this._pubSubTokens.forEach(PubSub.unsubscribe);
        super.destroy(pOptions);
    }

    public onResize() {
        this.reFocus();
    }

    private onFocusBegin(pTopic: string, pFocusable: HLF.Input.IFocusable): void {
        const focus: KeyboardFocus = this.getFocus();
        this.addChild(focus);
        focus.show(pFocusable);
        this._activeFoci.push(focus);
    }

    private onFocusEnd(pTopic: string, pFocusable: HLF.Input.IFocusable): void {
        for (let i = 0; i < this._activeFoci.length; ++i) {
            if (this._activeFoci[i].target === pFocusable) {
                const focus: KeyboardFocus = this._activeFoci[i];
                focus.hide(() => {
                    this.removeChild(focus);
                    this._activeFoci.splice(this._activeFoci.indexOf(focus), 1);
                    this._focusPool.push(focus);
                });
            }
        }
    }

    private onFocusableInteractiveChanged(pTopic: string, pFocusable: HLF.Input.IFocusable): void {
        for (let i = this._activeFoci.length - 1; i >= 0; --i) {
            if (this._activeFoci[i].target === pFocusable) {
                this._activeFoci[i].updateState();
            }
        }
    }

    private reFocus(): void {
        if (this._activeFoci.length > 0) {
            const focus: KeyboardFocus = this._activeFoci[this._activeFoci.length - 1];
            focus.fitToTarget();
        }
    }

    private getFocus(): KeyboardFocus {
        let focus: KeyboardFocus;
        if (this._focusPool.length > 0) {
            focus = this._focusPool.pop()!;
        }
        else {
            focus = new KeyboardFocus();
        }
        return focus;
    }
}
